export class SpriteAnimation {
  constructor(url, col, row, speed) {
    this.img = new Image()
    this.img.src = url
    this.loaded = false
    this.time = 0
    this.speed = speed || 1
    this.col = col
    this.row = row
    this.img.onload = (e) => {
      this.loaded = true
      this.spriteWidth = this.img.width / this.col
      this.spriteHeight = this.img.height / this.row
    }
  }

  render(ctx, pos, scale) {
    if (!this.loaded) return

    const frame = Math.round(this.time)
    ctx.drawImage(this.img,
      this.spriteWidth * (frame % this.col),
      this.spriteHeight * (Math.floor(frame / this.col)),
      this.spriteWidth,
      this.spriteHeight,
      pos.x - this.spriteWidth*0.5 * scale,
      pos.y - this.spriteHeight*0.5 * scale,
      this.spriteWidth * scale,
      this.spriteHeight * scale
    )
    this.time += this.speed
    if (this.time >= this.row * this.col) {
      this.time = 0
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/SpriteAnimation.js